import * as React from "react";
import './FormContainer.css';
import {isMobile} from "react-device-detect";
import {observer} from "mobx-react";
import * as  queryString from 'query-string';

import {FormComponent} from "../../state/FormsState";
import {Cookies} from "react-cookie";
import {RouteComponentProps} from "react-router";
import {CoverageState} from "../../state/CoverageState";
import {PartnersState} from "../../state/PartnersState";
import {BrokersState} from "../../state/BrokersState";
import {CancelStates} from "../../state/CancelStates";
import {Header} from "../../../../components/Header/Header";
import {UpgradeState} from "../../state/UpgradeState";
import {formStores} from "../../state/mobx";
import {MyAccountStores} from "../../../MyAccount/state/mobx";
import NavigationConstants from "src/scenes/Navigation/NavigationConstants";
import Icon from "../../../../components/Icon/Icon";
import ProgressBar from "../../../../components/ProgressBar/ProgressBar";
import SignUpForm from "../../components/SignUpForm/SignUpForm";
import FormWelcome from "../../screens/SignUpForm/FormWelcome/FormWelcome";
import FormBusiness from "../../screens/SignUpForm/FormBusiness/FormBusiness";
import FormVerification from "../../screens/SignUpForm/FormVerification/FormVerification";
import FormFinish from "../../screens/SignUpForm/FormFinish/FormFinish";
import FormPayment from "../../screens/SignUpForm/FormPayment/FormPayment";
import FormCoverage from "../../screens/FormAddCoverage/FormCoverage/FormCoverage";
import FormPartner from "../../screens/FormPartners/FormPartners/FormPartner";
import FormBroker from "../../screens/FormBrokers/FormBrokers/FormBroker";
import FormCancellationSteps from "../../screens/FormCancel/FormCancellationSteps/FormCancellationSteps";
import FormUpgrade from "../../screens/FormUpgradePlan/FormUpgrade/FormUpgrade";
import FormPlanSelector from "../../screens/SignUpForm/FormPlanSelector/FormPlanSelector";
// @ts-ignore
import salaryoLogoBlack from "../../../../assets/images/logo_black.svg"
import Loader from "../../../../components/Loader/Loader";
import FormWWD from "../../screens/FormWWD/FormWWD";
import LendioWelcome from "../../screens/FormLendio/LendioWelcome/LendioWelcome";
import {LendioState} from "../../state/LendioState";
import FormFinancialContainer from "../../screens/SignUpForm/FormFinancial/FormFinancialContainer";
import {LeadPlanType} from "shared/functions/membersApi/types/ISignupProcess";
import {IGooglePlace} from "shared/model/ICoworkGeoLocation";
import FormConnectBank from "../../screens/FormConnectBank/FormConnectBank";
import {IApplicationPath} from "shared/model/IApplication";
import FormSBA from "../../screens/FormSBA/FormSBA";
import {SBAPages} from "../../screens/FormSBA/FormSBASteps/SBATypes";
import WelcomeModalMobile from "../../screens/FormQuickApplication/QuickApplicationMobileModal/WelcomeModalMobile";
import FormBankSelectionContainer from "../../screens/SignUpForm/FormBankSelection/FormBankSelectionContainer";
import FormTermsAndConditions from "../../screens/SignUpForm/FormT&C/FormT&C";
import FormManageLoanPlan from "../../screens/FormManageLoanPlan/FormManageLoanPlan";

// @ts-ignore
import BUSINESS_DETAILS_CHARACTER from "../../../../assets/images/bussiness_character.png"
// @ts-ignore
import FINANCIAL_DETAILS_CHARACTER from "../../../../assets/images/finance_character.png"
// @ts-ignore
import BANK_SELECTION_CHARACTER from "../../../../assets/images/bank_details_character.png"
// @ts-ignore
import VERIFICATION_PAGE_CHARACTER from "../../../../assets/images/verification_character.png"
// @ts-ignore
import PAYMENT_PAGE_CHARACTER from "../../../../assets/images/payment_character.png"
// @ts-ignore
import FINAL_PAGE_CHARACTER from "../../../../assets/images/final_characters.png"

// @ts-ignore
import BUSINESS_DETAILS_BG from "../../../../assets/images/welcome_bg.png"
// @ts-ignore
import FINANCIAL_DETAILS_BG from "../../../../assets/images/finance_bg.png"
// @ts-ignore
import BANK_SELECTION_BG from "../../../../assets/images/bank_detais_bg.png"
// @ts-ignore
import VERIFICATION_PAGE_BG from "../../../../assets/images/verification_bg.png"
// @ts-ignore
import PAYMENT_PAGE_BG from "../../../../assets/images/payment_bg.png"
// @ts-ignore
import FINAL_PAGE_BG from "../../../../assets/images/final_bg.png"

const signUpStore = formStores.formStore;
const coverageStore = formStores.coverageStore;
const partnersStore = formStores.partnersStore;
const brokersStore = formStores.brokersStore;
const upgradeStore = formStores.upgradeStore;
const cancelStore = formStores.cancelStore;
const lendioStore = formStores.shortSignupStore;
const replaceCardStore = MyAccountStores.replaceCardStore;
const sbaLoanStore = formStores.sbaLoanStore;
const manageLoanStore = formStores.manageLoanStore;

const HEADERS = {
    generalWelcome: "Growth is a state of mind.",
    generalFinancial: "Connect your bank account",
    generalPlanSelect: "Every business needs a plan",
    generalPayment: "How you'll pay",
    manageLoan: "Manage your loan",
    signup: {
        business: "Nice to meet you",
        business_quick_application: "Welcome to Salaryo",
        verification: "Verify your info",
        paymentProcessing: "Processing",
    },
    addCoverage: {
        getStarted: "Get started",
        verification: "Verify your info"
    },
    cancel: {
        welcome: "Cancel your plan"
    },
    manuallyBankDetails: "Complete bank details",
    SBA_LOAN: {
        SBA_MAIN: "Paycheck Protection Program",
        SBA_MAIN_CALCULATOR: "Calculate your loan amount",
        SBA_SUB_BUSINESS: "The SBA Paycheck Protection Program is a loan designed to provide a direct incentive for small businesses to keep their workers on the payroll. Use this free tool to see how much you are eligible for, and submit the application instantly to your bank. All amounts calculated are an estimation for reference only and do not reflect the bank's final decision.",
        SBA_SUB_CALCULATOR: "Use this free calculator to determine your estimated eligible loan amount.",
        SBA_SUB_FINANCE: "The loan will be fully forgiven if the funds are used for payroll costs, interest on mortgages, rent, and utilities. At least 75% of the forgiven amount must have been used for payroll. Loan payments will be deferred for six months. No collateral or personal guarantees are required.",
        SBA_SUB_OWNERSHIP: "Complete ownership information is required to review your application.",
        SBA_SUB_GENERAL: "Respond to the following questions to continue with your application.",
        SBA_SUB_REQUIRE_DOCS: "To finalize the process, please upload the required supporting documents.",
        SBA_SUB_FINAL_PAGE: "The SBA Paycheck Protection Program is a loan designed to provide a direct incentive for small businesses to keep their workers on the payroll. Use this free tool to see how much you are eligible for, and submit the application instantly to your bank. All amounts calculated are an estimation for reference only and do not reflect the bank's final decision."
    }
};

const DEFAULT_NY_WORKSPACE: IGooglePlace = {
    id: "ChIJpbfBMopZwokRxQO9o47tUI0",
    name: "New York",
    formattedAddress: "447 Broadway 2nd floor, New York, NY 10013, United States"
}

interface IProps extends RouteComponentProps<any>{
    applicationInfo?: IApplicationPath;
    initialComponent? :FormComponent;
    initialPlan?: LeadPlanType | undefined;
    isInOnBoardingModal?: boolean;
    closeWWonBoardingModal? : () => void;
}

interface ILocalState {
    isSBALoanForm: boolean
    SBALoanModalStatus: boolean;
}

@observer
export default class FormContainer  extends React.Component<
    IProps,
    ILocalState
    > {
    public state: ILocalState = {
        isSBALoanForm: false,
        SBALoanModalStatus: false,
    };

    public placeholderBG: string = BUSINESS_DETAILS_BG;
    public characterImage: string = BUSINESS_DETAILS_CHARACTER;

    public componentDidMount(): void {
        const urlParams = queryString.parse(this.props.location.search);
        const pathName = this.props.location.pathname;
        this.handleCookiesAndURLData(urlParams, pathName);
        this.setLeadIdIfNeeded(urlParams);
        this.setInitialPlanAndLocationIfNeeded(this.props.initialPlan);
        this.setSBAFormStylingIfNeeded(pathName);
    };

    public setStageExternal = (uid: string) => {
        signUpStore.setUID(uid);
        signUpStore.setIsLoading(true);
        signUpStore.getUserStage(uid);

    };

    public renderFormComponent = () => {
        const {initialComponent} = this.props;
        window.scrollTo(0, 0);
        if(!initialComponent) {
            switch (signUpStore.currentComponent) {
                case FormComponent.welcome:return (<FormWelcome {...this.props}  store={signUpStore}/>);
                case FormComponent.planSelect:return (<FormPlanSelector {...this.props}  store={signUpStore}/>);
                case FormComponent.business: return (<FormBusiness store={signUpStore} {...this.props}/>);
                case FormComponent.financial: return (<FormFinancialContainer store={signUpStore}/>);
                case FormComponent.bankSelection: return (<FormBankSelectionContainer store={signUpStore}/>);
                case FormComponent.termsAndConditions: return (<FormTermsAndConditions {...this.props}/>);
                case FormComponent.payment: return (<FormPayment {...this.props} store={signUpStore}/>);
                case FormComponent.verification: return (<FormVerification store={signUpStore}/>);
                case FormComponent.finish: return (<FormFinish  {...this.props} store={signUpStore} link={"http://www.salaryo.com"}/>);
                default: return  null;
            }
        }else {
            switch (initialComponent) {
                case FormComponent.coverage: return (<FormCoverage {...this.props} closeWindowNavigationPath={NavigationConstants.myAccount}/>);
                case FormComponent.cancel:   return (<FormCancellationSteps {...this.props} closeWindowNavigationPath={NavigationConstants.myAccount}/>);
                case FormComponent.upgrade: return (<FormUpgrade {...this.props} closeWindowNavigationPath={NavigationConstants.myAccount}/>);
                case FormComponent.manageLoan: return (<FormManageLoanPlan {...this.props} store={manageLoanStore} isSending={manageLoanStore.isSending} closeWindowNavigationPath={NavigationConstants.myAccount}/>);
                case FormComponent.partners: return (<FormPartner {...this.props} closeWindowNavigationPath={NavigationConstants.partners}/>);
                case FormComponent.brokers: return (<FormBroker {...this.props} closeWindowNavigationPath={NavigationConstants.brokers}/>);
                case FormComponent.payment: return <FormPayment {...this.props} store={replaceCardStore} />;
                case FormComponent.ww: {
                    if (this.props.closeWWonBoardingModal){
                        return <FormWWD closeModal={this.props.closeWWonBoardingModal} closeWindowNavigationPath={NavigationConstants.myAccount}  {...this.props} />;
                    }
                }
                case FormComponent.lendio: return (<LendioWelcome {...this.props} />);
                case FormComponent.business: return (<FormBusiness store={signUpStore} {...this.props}/>);
                case FormComponent.connectBank: return (<FormConnectBank {...this.props}/>);
                case FormComponent.SBAForm: return (<FormSBA store={sbaLoanStore} {...this.props} />);
                default: return  null;
            }
        }
    };


    public renderLogoContainer = () => {
        return <div className={"logo-container"}><img alt={"logo"} src={salaryoLogoBlack}/></div>;
    }

    public getPageHeaders = () => {
        const {initialComponent} = this.props;
        if(this.state.isSBALoanForm) {
            switch (sbaLoanStore.currentPage) {
                case SBAPages.business: return (<div className="welcome-header sba">{HEADERS.SBA_LOAN.SBA_MAIN}</div>);
                case SBAPages.loanCalculator: return (<div className="welcome-header sba">{HEADERS.SBA_LOAN.SBA_MAIN_CALCULATOR}</div>);
                default: return (<div className="welcome-header sba">{HEADERS.SBA_LOAN.SBA_MAIN}</div>);
            }
        }
        if(!initialComponent) {
            switch (signUpStore.currentComponent) {
                case FormComponent.welcome: return (<div className="welcome-header">{HEADERS.generalWelcome}</div>);
                case FormComponent.business: {
                    return signUpStore.isQuickApplication? <div className="welcome-header"><div>{HEADERS.signup.business_quick_application}</div></div> :  <div className="welcome-header"><div>{HEADERS.signup.business}</div></div>;
                }
                case FormComponent.financial: return <div className="welcome-header">{HEADERS.generalWelcome}</div>;
                case FormComponent.bankSelection: return <div className="welcome-header">{HEADERS.manuallyBankDetails}</div>;
                case FormComponent.verification: return <div className="welcome-header">{HEADERS.signup.verification}</div>;
                case FormComponent.planSelect: return <div className="welcome-header">{HEADERS.generalPlanSelect}</div>;
                case FormComponent.payment: {
                    if(signUpStore.showFinishPaymentAnimation) {
                        return <div className="welcome-header"><div>{HEADERS.signup.paymentProcessing}</div></div>
                    }else {
                        return <div className="welcome-header"><div>{HEADERS.generalPayment}</div></div>
                    }
                }
                case FormComponent.finish: return '';
                default: return null;
            }
        }else {
            switch (initialComponent) {
                case FormComponent.coverage: {
                    switch (coverageStore.currentScreen) {
                        case CoverageState.financial: return (<div className="welcome-header">{HEADERS.generalWelcome}</div>);
                        case CoverageState.finish: return (<> </>)
                    }
                }
                case FormComponent.upgrade: {
                    switch (upgradeStore.currentScreen) {
                        case UpgradeState.verification: return (<div className="welcome-header">{HEADERS.generalPlanSelect}</div>);
                        case UpgradeState.finish: return null;
                    }
                }
                case FormComponent.partners: {
                    switch (partnersStore.currentScreen) {
                        case PartnersState.welcome: return (<div className="welcome-header">
                            <div>Looking to grow your workspace?</div>
                            <div>We got you covered.</div>
                        </div>);
                        case PartnersState.information:
                            return (<div className="welcome-header">
                                <div>Tell us more about yourself</div>
                                <div className="sub-header">
                                    We would love to get to know more about you and your <br/>
                                    workspace
                                </div>
                            </div>);
                        case PartnersState.finish: return <> </>;
                    }
                }
                case FormComponent.brokers: {
                    switch (brokersStore.currentScreen) {
                        case BrokersState.welcome: return (<div className="welcome-header">
                            Your clients. Your deals.<br/>
                            We’re here to help you get it done.
                        </div>);
                        case BrokersState.informationContact:
                            return (<div className="welcome-header">Looking to refer a client?<br/> Tell us more about them here</div>);
                        case BrokersState.informationClients:
                            return (<div className="welcome-header">Tell us more about:<br/> Yourself</div>);
                        case BrokersState.finish: return <> </>;
                        default: return  null;
                    }
                }
                case FormComponent.cancel: {
                    switch (cancelStore.currentScreen) {
                        case CancelStates.welcome: return (<div className="welcome-header">{HEADERS.cancel.welcome}</div>);
                        case CancelStates.finish: return <> </>;
                        default: return  null;
                    }
                }
                case FormComponent.payment: return (<div className="welcome-header">{HEADERS.generalPayment}</div>);
                case FormComponent.lendio: {
                    switch (lendioStore.currentComponent) {
                        case LendioState.welcome: return (<div className="welcome-header"><div>{HEADERS.generalWelcome}</div></div>);
                        case LendioState.verification: return (<div className="welcome-header">{HEADERS.addCoverage.verification}</div>);
                        case LendioState.bankSelection: return <div className="welcome-header">{HEADERS.manuallyBankDetails}</div>;
                        case LendioState.financial: return (<div className="welcome-header">{HEADERS.generalFinancial}</div>);
                        case LendioState.payment: return <div className="welcome-header"><div>{HEADERS.generalPayment}</div></div>;
                        default: return  null;
                    }
                }
                case FormComponent.connectBank: return (<div className="welcome-header">{HEADERS.generalFinancial}</div>);
                case FormComponent.manageLoan: {
                    if(!manageLoanStore.success) {
                        return <div className="welcome-header">{HEADERS.manageLoan}</div>;
                    }
                    return null;
                }
                default: return  '';
            }
        }
    };

    public renderFormPlaceholder = () => {
        return isMobile || this.props.isInOnBoardingModal?  null : <div className={"placeholder"} style={{backgroundImage: `url(${this.placeholderBG})`}}>
            {this.renderLogoContainer()}
            {this.getPageHeaders()}
            {this.renderSubHeaderIfNeeded()}
            {this.renderEmptyDivsWithBackgroundPlaceHolders()}
            <div className="img-container"><img src={this.characterImage}/></div>

        </div>
    };

    public renderMobileHeader = () => {
        return isMobile || this.props.initialComponent === FormComponent.ww ? <Header/> : null;
    };

    public renderSecurityIcons = () => {
        return (
            <>
                <div className="security-icons">
                    <div className='icons-container'>
                        <div className="icons"> <Icon icon={'security'}/> </div>
                        <div className="security-text">Your data is safe with us</div>
                    </div>
                </div>
            </>
        )
    };

    public getProgressBarCurrentStep = () => {
        const {initialComponent} = this.props;
        if(initialComponent) {
            if(this.state.isSBALoanForm) {
                return sbaLoanStore.currentPage
            }
            return " ";
        } else {
            return signUpStore.currentComponent;
        }

    };

    public  getProgressBarSteps = () => {
        if(this.state.isSBALoanForm) {
            return [SBAPages.business, SBAPages.loanCalculator, SBAPages.finance, SBAPages.ownership, SBAPages.general, SBAPages.firstThankYou];
        }
        return [FormComponent.business, FormComponent.financial, FormComponent.bankSelection, FormComponent.verification, FormComponent.payment]
    }

    public showModalBg = () => {
        return cancelStore.isModalOpen;
    };

    public closeModal = () => {
        cancelStore.updateModalStatus(false);
    }

    public closeSBAMobileModal = () => {
        const newState = this.state;
        newState.SBALoanModalStatus = false;
        this.setState(newState);
    }

    public render() {
        const {SBALoanModalStatus, isSBALoanForm} = this.state;
        const classes = isMobile? "signUp-container-mobile": "signUp-container";
        this.updateFormAssets();
        return (
            <>
                <div className={classes + (this.props.initialComponent === FormComponent.ww? " modal-form" : "")}>
                    {this.renderMobileHeader()}
                    {this.renderFormPlaceholder()}
                    <div className="form-container">
                        {isMobile && isSBALoanForm && SBALoanModalStatus ? <WelcomeModalMobile isSBALoan={true} onClose={this.closeSBAMobileModal}/> : null}
                        {this.showModalBg()? <div className="modal-bg" onClick={this.closeModal}/> : null}
                        {
                            signUpStore.isLoading? <div className="form-loader-container"> <Loader/> </div> :
                                <>
                                    {this.renderProgressBarIfNeeded()}
                                    <SignUpForm {...this.props}
                                                isPayment={signUpStore.currentComponent === FormComponent.payment}
                                                isMobilePayment={isMobile && signUpStore.currentComponent === FormComponent.payment}>
                                        {this.renderFormComponent()}
                                    </SignUpForm>
                                </>
                        }
                        {!isMobile?this.renderSecurityIcons(): null}
                    </div>
                </div>
            </>
        );
    };

    private updateFormAssets = (): void | string => {
        const {initialComponent} = this.props;
        if (!initialComponent) {
            switch (signUpStore.currentComponent) {
                case FormComponent.planSelect:
                case FormComponent.business:
                case FormComponent.welcome: {
                    this.updatePlaceholderAssets(BUSINESS_DETAILS_BG, BUSINESS_DETAILS_CHARACTER);
                    return;
                }
                case FormComponent.financial: {
                    this.updatePlaceholderAssets(FINANCIAL_DETAILS_BG, FINANCIAL_DETAILS_CHARACTER);
                    return;
                }
                case FormComponent.bankSelection: {
                    this.updatePlaceholderAssets(BANK_SELECTION_BG, BANK_SELECTION_CHARACTER);
                    return;
                }
                case FormComponent.verification: {
                    this.updatePlaceholderAssets(VERIFICATION_PAGE_BG, VERIFICATION_PAGE_CHARACTER);
                    return;
                }
                case FormComponent.payment: {
                    this.updatePlaceholderAssets(PAYMENT_PAGE_BG, PAYMENT_PAGE_CHARACTER);
                    return;
                }
                case FormComponent.finish: {
                    this.updatePlaceholderAssets(FINAL_PAGE_BG, FINAL_PAGE_CHARACTER);
                    return;
                }
                default:
                    return;
            }
        } else {
            switch (initialComponent) {
                case FormComponent.coverage: {
                    switch (coverageStore.currentScreen) {
                        case CoverageState.financial: {
                            this.updatePlaceholderAssets(FINANCIAL_DETAILS_BG, FINANCIAL_DETAILS_CHARACTER);
                            return;
                        }
                        case CoverageState.finish: {
                            this.updatePlaceholderAssets(FINAL_PAGE_BG, FINAL_PAGE_CHARACTER);
                            return;
                        }
                    }
                }
                case FormComponent.partners: {
                    switch (partnersStore.currentScreen) {
                        case PartnersState.welcome: {
                            this.updatePlaceholderAssets(BUSINESS_DETAILS_BG, BUSINESS_DETAILS_CHARACTER);
                            return;
                        }
                        case PartnersState.information: {
                            this.updatePlaceholderAssets(FINANCIAL_DETAILS_BG, FINANCIAL_DETAILS_CHARACTER);
                            return;
                        }
                        case PartnersState.finish: {
                            this.updatePlaceholderAssets(FINAL_PAGE_BG, FINAL_PAGE_CHARACTER);
                            return;
                        }
                        default: {
                            this.updatePlaceholderAssets(BUSINESS_DETAILS_BG, BUSINESS_DETAILS_CHARACTER);
                            return;
                        }
                    }
                }
                case FormComponent.brokers: {
                    switch (brokersStore.currentScreen) {
                        case BrokersState.welcome: {
                            this.updatePlaceholderAssets(BUSINESS_DETAILS_BG, BUSINESS_DETAILS_CHARACTER);
                            return;
                        }
                        case BrokersState.informationClients:
                        case BrokersState.informationContact: {
                            this.updatePlaceholderAssets(FINANCIAL_DETAILS_BG, FINANCIAL_DETAILS_CHARACTER);
                            return;
                        }
                        case BrokersState.finish: {
                            this.updatePlaceholderAssets(FINAL_PAGE_BG, FINAL_PAGE_CHARACTER);
                            return;
                        }
                        default: {
                            this.updatePlaceholderAssets(BUSINESS_DETAILS_BG, BUSINESS_DETAILS_CHARACTER);
                            return;
                        }
                    }
                }
                case FormComponent.upgrade: {
                    switch (coverageStore.currentScreen) {
                        case CoverageState.financial:{
                            this.updatePlaceholderAssets(FINANCIAL_DETAILS_BG, FINANCIAL_DETAILS_CHARACTER);
                            return;
                        }
                        case CoverageState.finish:{
                            this.updatePlaceholderAssets(FINAL_PAGE_BG, FINAL_PAGE_CHARACTER);
                            return;
                        }
                    }
                }
                case FormComponent.payment: {
                    this.updatePlaceholderAssets(PAYMENT_PAGE_BG, PAYMENT_PAGE_CHARACTER);
                    return;
                }
                case FormComponent.cancel: {
                    switch (cancelStore.currentScreen) {
                        case CancelStates.welcome: {
                            this.updatePlaceholderAssets(BUSINESS_DETAILS_BG, BUSINESS_DETAILS_CHARACTER);
                            return;
                        }
                        case CancelStates.finish: {
                            this.updatePlaceholderAssets(FINAL_PAGE_BG, FINAL_PAGE_CHARACTER);
                            return;
                        }
                        default: {
                            this.updatePlaceholderAssets(BUSINESS_DETAILS_BG, BUSINESS_DETAILS_CHARACTER);
                            return;
                        }
                    }
                }
                case FormComponent.lendio: {
                    switch (lendioStore.currentComponent) {
                        case LendioState.welcome: {
                            this.updatePlaceholderAssets(BUSINESS_DETAILS_BG, BUSINESS_DETAILS_CHARACTER);
                            return;
                        }
                        case LendioState.bankSelection: {
                            this.updatePlaceholderAssets(BANK_SELECTION_BG, BANK_SELECTION_CHARACTER);
                            return;
                        }
                        case LendioState.financial: {
                            this.updatePlaceholderAssets(FINANCIAL_DETAILS_BG, FINANCIAL_DETAILS_CHARACTER);
                            return;
                        }
                        case LendioState.verification: {
                            this.updatePlaceholderAssets(VERIFICATION_PAGE_BG, VERIFICATION_PAGE_CHARACTER);
                            return;
                        }
                        case LendioState.payment: {
                            this.updatePlaceholderAssets(PAYMENT_PAGE_BG, PAYMENT_PAGE_CHARACTER);
                            return;
                        }
                        case LendioState.thankYou: {
                            this.updatePlaceholderAssets(FINAL_PAGE_BG, FINAL_PAGE_CHARACTER);
                            return;
                        }
                        default:
                            return BUSINESS_DETAILS_CHARACTER;
                    }
                }
                case FormComponent.connectBank: {
                    this.updatePlaceholderAssets(FINANCIAL_DETAILS_BG, FINANCIAL_DETAILS_CHARACTER);
                    return;
                }
                case FormComponent.manageLoan: {
                    manageLoanStore.success ? this.updatePlaceholderAssets(FINAL_PAGE_BG, FINAL_PAGE_CHARACTER) : this.updatePlaceholderAssets(FINAL_PAGE_BG, FINANCIAL_DETAILS_CHARACTER)
                    return;
                }
            }
        }
    }

    private updatePlaceholderAssets = (background: string, character: string) => {
        this.placeholderBG = background;
        this.characterImage = character;
    };

    private handleCookiesAndURLData =  (urlParams: any, pathName: string) => {
        const cookies = new Cookies();
        if( urlParams.id === "resetCookie" || this.props.isInOnBoardingModal) {
            cookies.remove('uid');
        }else if(cookies.get('uid')) {
            this.setStageExternal(cookies.get('uid'));
        } else if (urlParams.cowork && urlParams.id) {
            if (pathName === NavigationConstants.shortSignup){
                lendioStore.setUid(urlParams.id);
                lendioStore.setCowork(urlParams.cowork);
                lendioStore.getApplicationData(urlParams.id, urlParams.cowork);
            }
            if (pathName === NavigationConstants.sbaLoan) {
                sbaLoanStore.setApp(urlParams.id, urlParams.cowork)
            }
        } else if(urlParams.id && pathName !== NavigationConstants.connectPlaid) {
            this.setStageExternal(urlParams.id);
        }
    };

    private setInitialPlanAndLocationIfNeeded = (plan: LeadPlanType | undefined) => {
        if(!plan) {
            return
        }
        signUpStore.formInput.welcome = {
            cowork: DEFAULT_NY_WORKSPACE
        };
        signUpStore.formInput.plans = {
            plansValue: plan,
        };
        signUpStore.isQuickApplication = true;
        signUpStore.showResetFormButton = false;
        signUpStore.updateCurrentComponent(FormComponent.business);
    }

    private setLeadIdIfNeeded = (urlParams: any) => {
        if(urlParams.ref) {
            signUpStore.referralId = urlParams.ref;
        }
    };

    private renderSubHeaderIfNeeded = () => {
        if( (signUpStore.formInput.plans && (signUpStore.formInput.plans.plansValue === LeadPlanType.Loan || signUpStore.formInput.plans.plansValue === LeadPlanType.Rent))  && signUpStore.currentComponent === FormComponent.business) {
            return (
                <div className="quick-loan-text">
                    Affordable business loans, up to $250,000. <br/>  Apply in minutes and get funded on the same day.
                </div>
            )
        }
        if(this.state.isSBALoanForm) {
            return (
                <div className="quick-loan-text sba-sub-header">
                    {this.getSBALoanSubHeaders()}
                </div>
            )
        }
        return null;
    };

    private setSBAFormStylingIfNeeded = (path: string) => {
        if(path !== NavigationConstants.sbaLoan) {
            return;
        }
        const newState = this.state;
        newState.isSBALoanForm = true;
        newState.SBALoanModalStatus = true;
        this.setState(newState);
    }

    private getSBALoanSubHeaders = () => {
        switch (sbaLoanStore.currentPage) {
            case SBAPages.business: return HEADERS.SBA_LOAN.SBA_SUB_BUSINESS;
            case SBAPages.loanCalculator: return HEADERS.SBA_LOAN.SBA_SUB_CALCULATOR;
            case SBAPages.finance: return HEADERS.SBA_LOAN.SBA_SUB_FINANCE;
            case SBAPages.ownership: return HEADERS.SBA_LOAN.SBA_SUB_OWNERSHIP;
            case SBAPages.general: return HEADERS.SBA_LOAN.SBA_SUB_GENERAL;
            case SBAPages.firstThankYou: return HEADERS.SBA_LOAN.SBA_SUB_REQUIRE_DOCS;
            case SBAPages.finalThankYou: return HEADERS.SBA_LOAN.SBA_SUB_FINAL_PAGE;
            default: return null;
        }
    }

    private renderProgressBarIfNeeded = () => {
        if(isMobile) {
            return null
        }
        return <div className={"progress-bar-container"}><ProgressBar isSBAForm={this.state.isSBALoanForm} progressPages={this.getProgressBarSteps()} currentPage={this.getProgressBarCurrentStep()}/></div>;

    }

    private renderEmptyDivsWithBackgroundPlaceHolders = () => {
        return <>
            <img src={BUSINESS_DETAILS_CHARACTER} alt={''} style={{height:0, width:0}}/>
            <img src={FINANCIAL_DETAILS_CHARACTER} alt={''} style={{height:0, width:0}}/>
            <img src={BANK_SELECTION_CHARACTER} alt={''} style={{height:0, width:0}}/>
            <img src={VERIFICATION_PAGE_CHARACTER} alt={''} style={{height:0, width:0}}/>
            <img src={PAYMENT_PAGE_CHARACTER} alt={''} style={{height:0, width:0}}/>
            <img src={FINAL_PAGE_CHARACTER} alt={''} style={{height:0, width:0}}/>
            <img src={BUSINESS_DETAILS_BG} alt={''} style={{height:0, width:0}}/>
            <img src={FINANCIAL_DETAILS_BG} alt={''} style={{height:0, width:0}}/>
            <img src={BANK_SELECTION_BG} alt={''} style={{height:0, width:0}}/>
            <img src={VERIFICATION_PAGE_BG} alt={''} style={{height:0, width:0}}/>
            <img src={PAYMENT_PAGE_BG} alt={''} style={{height:0, width:0}}/>
            <img src={FINAL_PAGE_BG} alt={''} style={{height:0, width:0}}/>
                </>
        }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/layout/FormContainer/FormContainer.tsx